<template>
  <div class="row justify-content-center">
    <div class="col-lg-6">
      <div class="contentcontainer">
        <span class="h1 mb-3 d-block">
              {{$t('emptylist.headline')}}
        </span>
        <p>
          {{$t('emptylist.message')}}
        </p>
        <b-btn variant="primary" v-on:click="resetFilters()">
          {{$t('emptylist.cta')}}
        </b-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyList',

  methods: {
    resetFilters () {
      this.$emit('resetFilters')
    }
  }
}
</script>
